var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 40,
    viewBox: "0 0 69 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11286_40321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 61,
    height: 32,
    rx: 4,
    fill: "#FFF5E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 60,
    height: 31,
    rx: 3.5,
    stroke: "#F7B028"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1229 18.592V17.612L37.1349 11.2H38.6469L33.6769 17.612L32.9629 17.388H40.7889V18.592H32.1229ZM37.5689 21V18.592L37.6109 17.388V15.26H38.9269V21H37.5689ZM42.8256 21.084C42.5643 21.084 42.3403 20.9953 42.1536 20.818C41.9669 20.6313 41.8736 20.398 41.8736 20.118C41.8736 19.838 41.9669 19.6093 42.1536 19.432C42.3403 19.2547 42.5643 19.166 42.8256 19.166C43.0776 19.166 43.2923 19.2547 43.4696 19.432C43.6563 19.6093 43.7496 19.838 43.7496 20.118C43.7496 20.398 43.6563 20.6313 43.4696 20.818C43.2923 20.9953 43.0776 21.084 42.8256 21.084ZM45.0562 21V20.048L49.0462 16.198C49.4009 15.862 49.6622 15.568 49.8302 15.316C50.0075 15.0547 50.1242 14.8167 50.1802 14.602C50.2455 14.378 50.2782 14.1633 50.2782 13.958C50.2782 13.454 50.1009 13.0573 49.7462 12.768C49.3915 12.4787 48.8735 12.334 48.1922 12.334C47.6695 12.334 47.1982 12.4227 46.7782 12.6C46.3582 12.768 45.9942 13.034 45.6862 13.398L44.7342 12.572C45.1075 12.096 45.6069 11.732 46.2322 11.48C46.8669 11.2187 47.5622 11.088 48.3182 11.088C48.9995 11.088 49.5922 11.2 50.0962 11.424C50.6002 11.6387 50.9875 11.9513 51.2582 12.362C51.5382 12.7727 51.6782 13.258 51.6782 13.818C51.6782 14.1353 51.6362 14.448 51.5522 14.756C51.4682 15.064 51.3095 15.3907 51.0762 15.736C50.8429 16.0813 50.5069 16.4687 50.0682 16.898L46.5122 20.328L46.1762 19.782H52.0982V21H45.0562Z",
    fill: "#04021D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0163 16.0507L25.7518 13.8163C26.1387 13.499 25.9386 12.8776 25.4315 12.8512L21.9088 12.6396C21.6953 12.6265 21.5084 12.4942 21.4284 12.2959L20.134 9.01702C19.9472 8.55422 19.2934 8.55422 19.1065 9.01702L17.8122 12.2827C17.7321 12.481 17.5453 12.6132 17.3318 12.6264L13.7957 12.838C13.2886 12.8645 13.0885 13.4859 13.4754 13.8031L16.2109 16.0243C16.371 16.1565 16.451 16.3813 16.3977 16.5796L15.5037 19.9775C15.3836 20.4534 15.904 20.8368 16.331 20.5724L19.3067 18.6818C19.4935 18.5628 19.7203 18.5628 19.8938 18.6818L22.8828 20.5724C23.3099 20.8368 23.8303 20.4534 23.7101 19.9775L22.8161 16.5928C22.7761 16.3945 22.8428 16.183 23.0163 16.0507H23.0163Z",
    fill: "#F7B028"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0163 16.0507L25.7518 13.8163C26.1387 13.499 25.9386 12.8776 25.4315 12.8512L21.9088 12.6396C21.6953 12.6265 21.5084 12.4942 21.4284 12.2959L20.134 9.01702C19.9472 8.55422 19.2934 8.55422 19.1065 9.01702L17.8122 12.2827C17.7321 12.481 17.5453 12.6132 17.3318 12.6264L13.7957 12.838C13.2886 12.8645 13.0885 13.4859 13.4754 13.8031L16.2109 16.0243C16.371 16.1565 16.451 16.3813 16.3977 16.5796L15.5037 19.9775C15.3836 20.4534 15.904 20.8368 16.331 20.5724L19.3067 18.6818C19.4935 18.5628 19.7203 18.5628 19.8938 18.6818L22.8828 20.5724C23.3099 20.8368 23.8303 20.4534 23.7101 19.9775L22.8161 16.5928C22.7761 16.3945 22.8428 16.183 23.0163 16.0507H23.0163Z",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11286_40321",
    x: 0,
    y: 0,
    width: 69,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866493 0 0 0 0 0.945922 0 0 0 0 0.958333 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11286_40321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11286_40321",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/StarRating.a0debc14b1aae86bb2926521a477d3ce.svg";
export { ForwardRef as ReactComponent };